export function routes($stateProvider) {
    $stateProvider
        .state('app.lab.entities', {
        url: '/subentidades',
        abstract: true,
        template: '<div ui-view></div>'
    })
        .state('app.lab.entities.list', {
        url: '?{page:int}&{items:int}&{state:int}&order&sort&filter',
        controller: 'LmeListEntitiesController',
        controllerAs: 'vm',
        template: require('./directory/directory.view.html'),
        role: 'entidadesLMEList',
        title: 'Subentidades',
        params: {
            state: {
                value: 1,
                dynamic: true
            },
            page: {
                value: 1,
                dynamic: true
            },
            items: {
                value: 20,
                dynamic: true
            },
            order: {
                value: "id",
                dynamic: true
            },
            sort: {
                value: "desc",
                dynamic: true
            },
            filter: {
                dynamic: true
            }
        }
    })
        .state('app.lab.entities.details', {
        url: '/{id}',
        controller: 'LmeDetailsEntitiesController',
        controllerAs: 'vm',
        template: require('./details/details.view.html'),
        role: 'entidadesLMEList',
        title: 'Detalhes da Subentidade'
    });
}
routes.$inject = ['$stateProvider'];
